import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { Table, TableCreate, TableUpdate, TableListResponse } from '../types/api.types'

export const tablesService = {
  // property_id is required by the API. The response is wrapped in
  // { tables, total } — unwrap so callers match every other service here.
  async getAll(propertyId: number): Promise<Table[]> {
    const url = `${API_ENDPOINTS.TABLES}?property_id=${propertyId}`
    const { data } = await axiosInstance.get<TableListResponse>(url)
    return data.tables ?? []
  },

  async create(table: TableCreate): Promise<Table> {
    const { data } = await axiosInstance.post<Table>(API_ENDPOINTS.TABLES, table)
    return data
  },

  // PATCH, not PUT — partial update with meaningful nulls.
  async update(id: number, table: TableUpdate): Promise<Table> {
    const { data } = await axiosInstance.patch<Table>(API_ENDPOINTS.TABLE_BY_ID(id), table)
    return data
  },

  async delete(id: number): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.TABLE_BY_ID(id))
  },
}
